<img class="mobile-nav-img" src="./assets/img/logo-mobile-navabr.png" alt="LOGO_MOBILE">

<ul>
    <li> <a (click)="delayedNavigation($event)" href="#about-me">{{ "MOBILENAVBAR.ABOUT_ME" | translate }}</a>  </li>
    <li> <a (click)="delayedNavigation($event)" href="#skill">{{ "MOBILENAVBAR.SKILL_SET" | translate }}</a>  </li>
    <li> <a (click)="delayedNavigation($event)" href="#projects">{{ "MOBILENAVBAR.MY_WORK" | translate }}</a>  </li>
    <li> <a (click)="delayedNavigation($event)" href="#contact">{{ "MOBILENAVBAR.CONTACT" | translate }}</a>  </li>
</ul>
